import { render, staticRenderFns } from "./SDSubStatusView.vue?vue&type=template&id=526c85ba&scoped=true"
import script from "./SDSubStatusView.vue?vue&type=script&lang=js"
export * from "./SDSubStatusView.vue?vue&type=script&lang=js"
import style0 from "./SDSubStatusView.vue?vue&type=style&index=0&id=526c85ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526c85ba",
  null
  
)

export default component.exports